export const keyLocations = {
  India: {
    treatment_therapy: ['Equine Therapy'],
    who_we_treat: ['Adolescents', 'Executives'],
    treatment_method: ['Detox', 'Non 12 Step', 'Wellness'],
    onsite_activities: ['Equine'],
    treatment_therapies: ['Detox'],
    treatment_type: ['Detox'],
    what_we_treat: ['Depression', 'Eating Disorders', 'Anxiety', 'Trauma']
  },
  Australia: {
    treatment_therapy: ['Equine Therapy'],
    who_we_treat: ['Adolescents', 'Executives'],
    treatment_method: ['Detox', 'Non 12 Step', 'Wellness'],
    onsite_activities: ['Equine'],
    treatment_therapies: ['Detox'],
    what_we_treat: ['Depression', 'Eating Disorders', 'Anxiety', 'Trauma']
  },
  Ontario: {
    treatment_therapy: ['Equine Therapy'],
    who_we_treat: ['Adolescents', 'Executives'],
    treatment_method: ['Detox', 'Non 12 Step', 'Wellness'],
    onsite_activities: ['Equine'],
    treatment_therapies: ['Detox'],
    what_we_treat: ['Depression', 'Eating Disorders', 'Anxiety', 'Trauma']
  },
  'British Columbia': {
    treatment_therapy: ['Equine Therapy'],
    who_we_treat: ['Adolescents', 'Executives'],
    treatment_method: ['Detox', 'Non 12 Step', 'Wellness'],
    onsite_activities: ['Equine'],
    treatment_therapies: ['Detox'],
    what_we_treat: ['Depression', 'Eating Disorders', 'Anxiety', 'Trauma']
  },
  California: {
    treatment_therapy: ['Equine Therapy'],
    who_we_treat: ['Adolescents', 'Executives'],
    treatment_method: ['Detox', 'Detox', 'Non 12 Step', 'Wellness'],
    onsite_activities: ['Equine'],
    treatment_therapies: ['Detox'],
    what_we_treat: ['Depression', 'Eating Disorders', 'Anxiety', 'Trauma']
  },
  Florida: {
    treatment_therapy: ['Equine Therapy'],
    who_we_treat: ['Adolescents', 'Executives'],
    treatment_method: ['Detox', 'Non 12 Step', 'Wellness'],
    onsite_activities: ['Equine'],
    treatment_therapies: ['Detox'],
    what_we_treat: ['Depression', 'Eating Disorders', 'Anxiety', 'Trauma']
  },
  Thailand: {
    treatment_therapy: ['Equine Therapy'],
    who_we_treat: ['Adolescents', 'Executives'],
    treatment_method: ['Non 12 Step', 'Wellness'],
    onsite_activities: ['Equine'],
    treatment_therapies: ['Detox'],
    what_we_treat: ['Depression', 'Eating Disorders', 'Anxiety', 'Trauma']
  },
  Arizona: {
    treatment_therapy: ['Equine Therapy'],
    who_we_treat: ['Adolescents', 'Executives'],
    treatment_method: ['Detox', 'Non 12 Step', 'Wellness'],
    onsite_activities: ['Equine'],
    treatment_therapies: ['Detox'],
    what_we_treat: ['Depression', 'Eating Disorders', 'Anxiety', 'Trauma']
  },
  Texas: {
    treatment_therapy: ['Equine Therapy'],
    who_we_treat: ['Adolescents', 'Executives'],
    treatment_method: ['Detox', 'Non 12 Step', 'Wellness'],
    onsite_activities: ['Equine'],
    treatment_therapies: ['Detox'],
    what_we_treat: ['Depression', 'Eating Disorders', 'Anxiety', 'Trauma']
  },
  Switzerland: {
    treatment_therapy: ['Equine Therapy'],
    who_we_treat: ['Adolescents', 'Executives'],
    treatment_method: ['Detox', 'Non 12 Step', 'Wellness'],
    onsite_activities: ['Equine'],
    treatment_therapies: ['Detox'],
    what_we_treat: ['Depression', 'Eating Disorders', 'Anxiety', 'Trauma']
  },
  'Los Angeles': {
    treatment_therapy: ['Equine Therapy'],
    who_we_treat: ['Adolescents', 'Executives'],
    treatment_method: ['Detox', 'Non 12 Step', 'Wellness'],
    onsite_activities: ['Equine'],
    treatment_therapies: ['Detox'],
    what_we_treat: ['Depression', 'Eating Disorders', 'Anxiety', 'Trauma']
  },
  Malibu: {
    treatment_therapy: ['Equine Therapy'],
    who_we_treat: ['Adolescents', 'Executives'],
    treatment_method: ['Detox', 'Non 12 Step', 'Wellness'],
    onsite_activities: ['Equine'],
    treatment_therapies: ['Detox'],
    what_we_treat: ['Depression', 'Eating Disorders', 'Anxiety', 'Trauma']
  },
  Colorado: {
    treatment_therapy: ['Equine Therapy'],
    who_we_treat: ['Adolescents', 'Executives'],
    treatment_method: ['Detox', 'Non 12 Step', 'Wellness'],
    onsite_activities: ['Equine'],
    treatment_therapies: ['Detox'],
    what_we_treat: ['Depression', 'Eating Disorders', 'Anxiety', 'Trauma']
  },
  'United States': {
    treatment_therapy: ['Equine Therapy'],
    who_we_treat: ['Adolescents', 'Executives'],
    treatment_method: ['Detox', 'Non 12 Step', 'Wellness'],
    onsite_activities: ['Equine'],
    treatment_therapies: ['Detox'],
    what_we_treat: ['Depression', 'Eating Disorders', 'Anxiety', 'Trauma']
  },
  Pennsylvania: {
    treatment_therapy: ['Equine Therapy'],
    who_we_treat: ['Adolescents', 'Executives'],
    treatment_method: ['Detox', 'Non 12 Step', 'Wellness'],
    onsite_activities: ['Equine'],
    treatment_therapies: ['Detox'],
    what_we_treat: ['Depression', 'Eating Disorders', 'Anxiety', 'Trauma']
  },
  'New York': {
    treatment_therapy: ['Equine Therapy'],
    who_we_treat: ['Adolescents', 'Executives'],
    treatment_method: ['Detox', 'Non 12 Step', 'Wellness'],
    onsite_activities: ['Equine'],
    treatment_therapies: ['Detox'],
    what_we_treat: ['Depression', 'Eating Disorders', 'Anxiety', 'Trauma']
  },
  Georgia: {
    treatment_therapy: ['Equine Therapy'],
    who_we_treat: ['Adolescents', 'Executives'],
    treatment_method: ['Detox', 'Non 12 Step', 'Wellness'],
    onsite_activities: ['Equine'],
    treatment_therapies: ['Detox'],
    what_we_treat: ['Depression', 'Eating Disorders', 'Anxiety', 'Trauma']
  },
  Canada: {
    treatment_therapy: ['Equine Therapy'],
    who_we_treat: ['Adolescents', 'Executives'],
    treatment_method: ['Detox', 'Non 12 Step', 'Wellness'],
    onsite_activities: ['Equine'],
    treatment_therapies: ['Detox'],
    what_we_treat: ['Depression', 'Eating Disorders', 'Anxiety', 'Trauma']
  },
  'United Kingdom': {
    treatment_therapy: ['Equine Therapy'],
    who_we_treat: ['Adolescents', 'Executives'],
    treatment_method: ['Detox', 'Non 12 Step', 'Wellness'],
    onsite_activities: ['Equine'],
    treatment_therapies: ['Detox'],
    what_we_treat: ['Depression', 'Eating Disorders', 'Anxiety', 'Trauma']
  },
  Asia: {
    treatment_therapy: ['Equine Therapy'],
    who_we_treat: ['Adolescents', 'Executives'],
    treatment_method: ['Detox', 'Non 12 Step', 'Wellness'],
    onsite_activities: ['Equine'],
    treatment_therapies: ['Detox'],
    what_we_treat: ['Depression', 'Eating Disorders', 'Anxiety', 'Trauma']
  },
  Europe: {
    treatment_therapy: ['Equine Therapy'],
    who_we_treat: ['Adolescents', 'Executives'],
    treatment_method: ['Detox', 'Non 12 Step', 'Wellness'],
    onsite_activities: ['Equine'],
    treatment_therapies: ['Detox'],
    what_we_treat: ['Depression', 'Eating Disorders', 'Anxiety', 'Trauma']
  }
}

export default (state, rest) => {
  let urlParts = []
  if (
    state.refinementList &&
    state.refinementList.locations &&
    state.refinementList.locations.length == 1
  ) {
    urlParts.push(state.refinementList.locations[0])
  }

  if (state.menu && Object.keys(state.menu).length == 1) {
    if (state.menu[Object.keys(state.menu)[0]]) {
      urlParts.push(state.menu[Object.keys(state.menu)[0]])
    }
  }

  return `/${urlParts.join('/').toLowerCase().replace(/\ /g, '-')}/`.replace(
    'eating-disorder:-anorexia,-bulimia',
    'eating-disorders'
  )
}
